export const isMobileSafari = () =>
  /(iPod|iPhone|iPad)/.test(navigator.userAgent) &&
  /AppleWebKit/.test(navigator.userAgent);
